<template>
  <div>
    <b-modal
      hide-footer
      hide-backdrop
      title="Confirm"
      hide-header-close
      id="mymodal"
      ref="test"
    >
      <div>
        <label>
          <h4>Do you really want to update Status?</h4>
        </label>
        <div class="text-right">
          <button
            @click.prevent.stop="okUpdateStatus()"
            class="btn-blue mw-auto mr-3"
          >
            OK
          </button>
          <button
            @click.prevent.stop="cancelUpdateStatus()"
            class="btn-blue mw-auto mr-3"
          >
            Cancel
          </button>
        </div>
      </div>
    </b-modal>

    <div class="page-container">
      <div class="row pb-3">
        <div class="col-6 align-self-center">
          <div class="section-title test-class">{{ $t("shiftLogs", 2) }}</div>
        </div>
        <div class="col-3 align-self-cetner">
          <div class="searchbar-rounded">
            <input
              v-debounce:500="onSearch"
              v-model="searchValue"
              type="search"
              placeholder="Search"
            />
          </div>
        </div>
        <div class="col-3 align-self-center">
          <div class="d-flex w-100 justify-content-end">
            <a
              :href="PdfPath"
              target="_blank"
              download
              title="Download as PDF"
              v-if="PdfPath"
            >
              <img
                src="@/assets/img/icons/pdf-icon.svg"
                height="25"
                width="25"
              />
            </a>
            <span
              @click="excelDownload()"
              title="Download as Excel"
              style="cursor: pointer"
            >
              <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
            </span>
            <span class="mx-2"></span>
          </div>
        </div>
      </div>

      <div class="border-top border-bottom py-3 mb-3">
        <div class="row">
          <div class="col-9 align-self-center">
            <div class="d-flex">
              <button class="btn-transparent">
                <img
                  src="@/assets/img/icons/primary/filter.svg"
                  height="25"
                  width="25"
                />
              </button>

              <span class="mx-2"></span>

              <div class="">
                <div class="input-material">
                  <div class="add-datepicker">
                    <button
                      class="btn-clearDate"
                      v-if="startDate"
                      v-on:click="onClearDate('start')"
                    >
                      ✖
                    </button>
                    <Datepicker
                      :monday-first="true"
                      @selected="onSelectDate($event, 'start')"
                      ref="programaticOpen"
                      :value="startDate"
                      v-validate="'required'"
                      :typeable="true"
                    ></Datepicker>
                    <label :class="startDate ? 'active' : ''"
                      >{{ $t("start") }} {{ $t("date") }}</label
                    >
                  </div>
                </div>
                <!-- <small>Latest Date &times;</small> -->
              </div>

              <span class="mx-2"></span>

              <div class="">
                <div class="input-material">
                  <div class="add-datepicker">
                    <button
                      class="btn-clearDate"
                      v-if="endDate"
                      v-on:click="onClearDate('end')"
                    >
                      ✖
                    </button>
                    <Datepicker
                      :monday-first="true"
                      @selected="onSelectDate($event, 'end')"
                      ref="programaticOpen"
                      :value="endDate"
                      v-validate="'required'"
                      :typeable="true"
                    ></Datepicker>
                    <label :class="endDate ? 'active' : ''"
                      >{{ $t("end") }} {{ $t("date") }}</label
                    >
                  </div>
                </div>
                <!-- <small>Latest Date &times;</small> -->
              </div>

              <span class="mx-2"></span>

              <div>
                <b-dropdown
                  :text="shiftStatus"
                  variant="dropdown-curve"
                  class="ml-auto mr-3 movie-dropdown"
                >
                  <b-dropdown-item @click="onSwitchActive('All')"
                    >All</b-dropdown-item
                  >
                  <b-dropdown-item @click="onSwitchActive('Open')"
                    >Open</b-dropdown-item
                  >
                  <b-dropdown-item @click="onSwitchActive('Closed')"
                    >Closed</b-dropdown-item
                  >
                </b-dropdown>
              </div>

              <span class="mx-2"></span>
              <div class="col-lg-6 col-xl-3 align-self-center mb-2">
                <div class="dropdown-curve-container">
                  <label :class="cinemaList.length > 0 ? 'shift-up' : ''"
                    >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
                  >
                  <!-- <b-dropdown
                :disabled="isRoleID"
                :text="selected.cinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(Cinema, CinemaIndex) in CinemasList"
                  :key="CinemaIndex"
                  v-on:click="onSelectCinema($event, Cinema)"
                >{{ Cinema.cine_name }}</b-dropdown-item>
              </b-dropdown>-->
                  <multiselect
                    :disabled="isRoleID"
                    :options="cinemaList"
                    v-model="selectedCinema"
                    :searchable="true"
                    label="cine_name"
                    track-by="cine_id"
                    placeholder="Select Cinema"
                    @input="onSelectCinema($event)"
                    :allowEmpty="false"
                    :showLabels="false"
                  ></multiselect>
                </div>
              </div>

              <div>
                <button @click.prevent.stop="handleFetch()" class="btn-blue">
                  {{ $t("fetch") }}
                </button>
              </div>
            </div>
          </div>
          <div class="col-6"></div>
        </div>
      </div>

      <div class="swc-report">
        <table class="swc-report-table">
          <thead style="background-color: #fff; color: white">
            <td style="padding: 14px">{{ $tc("action") }}</td>
            <td>{{ $tc("status", 1) }}</td>
            <td>{{ $t("Shift Id") }}</td>
            <td>{{ $t("name") }}</td>
            <td>{{ $t("login_date_time") }}</td>
            <td>{{ $t("logout_date_time") }}</td>
            <td>{{ $t("Float Amount") }}</td>
            <!-- <td>Digital OrderId</td> -->
            <td>{{ $t("boxoffice_amount") }}</td>
            <td>{{ $tc("fnb_amount") }}</td>
            <td>{{ $t("collectionAmount") }}</td>
            <td>{{ $t("systemAmount") }}</td>
            <td>{{ $t("Excess / Shortage") }}</td>
          </thead>

          <tbody v-if="shiftsCLoseValues.length == 0">
            <tr>
              <td colspan="11">
                <NoRecords />
              </td>
            </tr>
          </tbody>
          <tbody v-if="shiftsCLoseValues.length > 0">
            <tr
              v-for="(shiftsCLoseValue,
              shiftsCLoseValueIndex) in shiftsCLoseValues"
              :key="shiftsCLoseValueIndex"
              style="border-bottom: 1px solid #f2f2f2"
            >
              <!-- <td style="padding: 14px;">
                <b-dropdown
                  right
                  variant="edit"
                  id="dropdown-dropright"
                  dropright
                  boundary="viewport"
                  class="align-self-end"
                >
                  <b-dropdown-item
                    v-if="shiftsCLoseValue.shift_end == 'Y'"
                    @click="
                      goToRoute(
                        '/cinema-manager/view-shift-close',
                        shiftsCLoseValue
                      )
                    "
                    >View Shift Close
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-if="shiftsCLoseValue.shift_end == 'Y'"
                    @click="
                      goToRoute(
                        '/cinema-manager/update-shift-close',
                        shiftsCLoseValue
                      )
                    "
                    >Edit Shift Close
                  </b-dropdown-item> -->
              <!-- <b-dropdown-item
                    v-if="shiftsCLoseValue.shift_end == 'Y'"
                    @click="
                      goToRoute(
                        '/cinema-manager/edit-shift-close',
                        shiftsCLoseValue
                      )
                    "
                    >Edit Shift Close
                  </b-dropdown-item> -->
              <!-- <b-dropdown-item
                    @click="
                      getShiftCloseInvoice(
                        shiftsCLoseValue.user_id,
                        shiftsCLoseValue.login_date_time,
                        shiftsCLoseValue.logout_date_time,
                        shiftsCLoseValue.shift_end,
                        false,
                        'Y',
                        shiftsCLoseValue.usl_id
                      )
                    "
                    >Preview Shift Close Pdf
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="shiftsCLoseValue.isEditedByTL == 'Y'"
                    @click="getRevenueDropReport(shiftsCLoseValue.usl_id)"
                    >View RDR Report
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="shiftsCLoseValue.isEditedByTL == 'Y'"
                    @click="showTLLogs(shiftsCLoseValue.usl_id)"
                    >TL Amount Logs
                  </b-dropdown-item>
                </b-dropdown>
              </td> -->
              <td style="padding: 14px">
                <div class="d-flex align-items-center justify-content-start">
                  <i
                    class="icon-eye blue-icon cursor-pointer ml-2"
                    @click.prevent.stop="
                      getShiftCloseInvoice(
                        shiftsCLoseValue.user_id,
                        shiftsCLoseValue.login_date_time,
                        shiftsCLoseValue.logout_date_time,
                        shiftsCLoseValue.shift_end,
                        false,
                        'Y',
                        shiftsCLoseValue.usl_id
                      )
                    "
                    v-b-tooltip="'View Shift Summary'"
                    tabindex="0"
                  ></i>
                  <div
                    class="blue-icon cursor-pointer ml-2"
                    @click.prevent.stop="
                      goToRoute(
                        '/cinema-manager/shift-logs-transactions',
                        shiftsCLoseValue
                      )
                    "
                    v-b-tooltip="'View Transactions'"
                    tabindex="0"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon icon-tabler icon-tabler-file-description"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      stroke-width="1"
                      stroke="var(--blue)"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M14 3v4a1 1 0 0 0 1 1h4" />
                      <path
                        d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
                      />
                      <path d="M9 17h6" />
                      <path d="M9 13h6" />
                    </svg>
                  </div>
                  <div
                    v-if="shiftsCLoseValue.shift_end == 'Y'"
                    class="blue-icon cursor-pointer ml-2"
                    @click.prevent.stop="
                      goToRoute(
                        '/cinema-manager/view-shift-close',
                        shiftsCLoseValue
                      )
                    "
                    v-b-tooltip="'View Shift Close'"
                    tabindex="0"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      fill="#8d6fbf"
                      class="bi bi-clock-fill"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"
                      />
                    </svg>
                  </div>
                  <i
                    v-if="shiftsCLoseValue.shift_end == 'Y'"
                    class="edit-pen blue-icon cursor-pointer ml-2"
                    @click.prevent.stop="
                      goToRoute(
                        '/cinema-manager/update-shift-close',
                        shiftsCLoseValue
                      )
                    "
                    v-b-tooltip="'Edit Shift Close'"
                    tabindex="0"
                  ></i>

                  <div
                    v-if="shiftsCLoseValue.isEditedByTL == 'Y'"
                    class="icon-eye blue-icon cursor-pointer ml-2"
                    @click.prevent.stop="
                      getRevenueDropReport(shiftsCLoseValue.usl_id)
                    "
                    v-b-tooltip="'View RDR Report'"
                    tabindex="0"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      fill="#8d6fbf"
                      class="bi bi-file-earmark-text"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"
                      />
                      <path
                        d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"
                      />
                    </svg>
                  </div>
                  <div
                    v-if="shiftsCLoseValue.isEditedByTL == 'Y'"
                    class="icon-eye blue-icon cursor-pointer ml-2"
                    @click.prevent.stop="showTLLogs(shiftsCLoseValue.usl_id)"
                    v-b-tooltip="'TL Amount Logs'"
                    tabindex="0"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      fill="#8d6fbf"
                      class="bi bi-file-earmark-fill"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3z"
                      />
                    </svg>
                  </div>
                </div>
              </td>

              <td
                :class="[
                  shiftsCLoseValue.shift_end === 'Y'
                    ? 'text-danger'
                    : 'text-success',
                ]"
              >
                {{
                  shiftsCLoseValue.shift_end &&
                  shiftsCLoseValue.shift_end === "Y"
                    ? "Shift Closed"
                    : shiftsCLoseValue.shift_end &&
                      shiftsCLoseValue.shift_end === "N"
                    ? "Running"
                    : ""
                }}
                <br />
                <span
                  :style="
                    shiftsCLoseValue.isEditedByTL === 'Y'
                      ? 'color:green !important'
                      : 'color:red !important'
                  "
                  >{{
                    shiftsCLoseValue.isEditedByTL &&
                    shiftsCLoseValue.isEditedByTL === "Y"
                      ? "RDR Created"
                      : shiftsCLoseValue.shift_end &&
                        shiftsCLoseValue.shift_end === "Y"
                      ? "RDR Pending"
                      : ""
                  }}</span
                >
              </td>
              <td>S{{ shiftsCLoseValue.usl_id }}</td>

              <td class="text-left">
                {{ shiftsCLoseValue.operator }}
                {{
                  shiftsCLoseValue.up_employee_code
                    ? `( ${shiftsCLoseValue.up_employee_code} )`
                    : ``
                }}
              </td>
              <td class="text-left">
                {{ shiftsCLoseValue.login_date_time | fulldatemonparse }}
              </td>
              <td v-if="shiftsCLoseValue.shift_end == 'Y'" class="text-left">
                {{ shiftsCLoseValue.logout_date_time | fulldatemonparse }}
              </td>
              <td v-else>-</td>

              <td class="text-right">
                {{ currFormat(shiftsCLoseValue.float_amount) }}
              </td>
              <td class="text-right">
                {{ currFormat(shiftsCLoseValue.BoxOfficeAmount) }}
              </td>
              <td class="text-right">
                {{ currFormat(shiftsCLoseValue.FnbAmount) }}
              </td>
              <td class="text-right">
                {{ currFormat(shiftsCLoseValue.collection_amount) }}
              </td>
              <td class="text-right">
                {{ currFormat(shiftsCLoseValue.system_amount) }}
              </td>
              <td
                :class="
                  shiftsCLoseValue.collection_amount -
                    shiftsCLoseValue.system_amount >
                  0
                    ? 'text-success'
                    : shiftsCLoseValue.collection_amount -
                        shiftsCLoseValue.system_amount <
                        0 && 'text-danger'
                "
                class="text-right"
              >
                {{
                  shiftsCLoseValue.shift_end === "Y"
                    ? parseFloat(
                        shiftsCLoseValue.collection_amount -
                          shiftsCLoseValue.system_amount
                      ).toFixed(MIN_FRACTION_DIGITS)
                    : "0.00"
                }}
              </td>
            </tr>
          </tbody>
        </table>
        <b-modal id="tlLog" size="xl" ref="tlLog" title="TL Logs" hide-footer>
          <div class="row">
            <div class="col-12">
              <table class="swc-report-table">
                <thead style="background-color: #fff; color: white">
                  <td>{{ $tc("Manager Name", 1) }}</td>
                  <td>{{ $t("Created At") }}</td>
                  <td>{{ $t("Created By") }}</td>
                  <td>{{ $t("Total Amount Collected") }}</td>
                </thead>

                <tbody v-if="shiftTLLogs.length == 0">
                  <tr>
                    <td colspan="4">
                      <NoRecords />
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="shiftTLLogs.length > 0">
                  <tr
                    v-for="(item, index) in shiftTLLogs"
                    :key="index"
                    v-if="index < shiftTLLogs.length - 1"
                  >
                    <td>{{ item.manager_name || "-" }}</td>
                    <td>{{ item.created_user_name || "-" }}</td>
                    <td>{{ item.created_at || "-" }}</td>
                    <td>{{ item.scr_total_amount_collected || "-" }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-modal>
        <div></div>
      </div>
    </div>
    <div class="w-full d-flex justify-content-center">
      <b-pagination
        :total-rows="rows"
        :per-page="perPage"
        v-model="currentPage"
        aria-controls="my-table"
        class="mb-0 justify-content-end"
        @change="onChangePagination($event)"
        v-if="shiftsCLoseValues && shiftsCLoseValues.length > 0"
      ></b-pagination>
    </div>
  </div>
</template>
<script>
  import CinemasService from "@/services/CinemasService";
  import moment from "moment";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import xlsx from "json-as-xlsx";
  import MasterService from "@/services/MasterService";
  import PosService from "@/services/PosService.js";

  export default {
    components: {
      NoRecords,
    },
    data() {
      return {
        login_date: null,
        logout_date: null,
        cinema_id: null,
        shiftsCLoseValues: [],
        submitted: "N",
        debounce: null,
        src_id2: null,
        manager_user_id2: null,
        status: "Y",
        payloadStatus: "Y",
        searchValue: null,
        selectedIndex: null,
        startDate: new Date(),
        endDate: new Date(),
        shiftStatus: "All",
        PdfPath: "",
        //
        perPage: 10,
        currentPage: 1,
        rows: 0,
        selectedvalue: "10",
        viewingnumbers: [
          { name: "All", id: 1 },
          { name: "10", id: 2 },
          { name: "20", id: 3 },
          { name: "30", id: 3 },
          { name: "40", id: 4 },
          { name: "50", id: 5 },
        ],
        selectedCinema: "",
        cinemaList: [],
        shiftTLLogs: [],
        isRoleID: false,
      };
    },
    beforeMount() {
      let obj = this.secureStore.get("USINFO").cinema_id;
      this.cinema_id = obj;

      let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      this.getCinemaList();
      if (CinemaObj) {
        this.onSelectCinema(CinemaObj);
      }
      // this.getShiftCloseList({});
      this.onSelectDate(this.startDate, "start");
      this.onSelectDate(this.endDate, "end");
      const { user_id, role_name } = this.secureStore.get("USINFO");
      console.log("role nammee", role_name);
    },
    mounted() {
      let roleid = this.secureStore.get("USINFO").role_id;
      if (true) {
        this.isRoleID = false;
      }
      let cinemaId =
        this.secureStore.get("USINFO") &&
        this.secureStore.get("USINFO")["cinema_id"]
          ? this.secureStore.get("USINFO").cinema_id
          : null;
      this.getCinemaList(cinemaId);
    },
    methods: {
      showTLLogs(usl_id) {
        let payload = {
          usl_id,
        };
        let loader = this.$loading.show();
        PosService.getTLLOgs(payload)
          .then((response) => {
            loader.hide();
            const { status, Records } = response.data;
            console.log(response);
            if (status && Records.length > 0) {
              this.shiftTLLogs = Records;
              this.$refs.tlLog.show();
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          })
          .finally(() => {});
      },
      getShiftCloseInvoice(
        user_id,
        login_date,
        logout_date,
        shift_status,
        isPrint = false,
        isPdf = false,
        usl_id
      ) {
        let loader = this.$loading.show();
        let payload = {
          user_id: user_id,
          fromDate: moment(login_date || new Date()).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
          toDate: moment(logout_date || new Date()).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
          isCurrentShift: shift_status == "Y" ? "N" : "Y",
          isPrint: isPrint,
          isPdf: isPdf,
          usl_id,
          isDashboard: "Y",
        };

        PosService.getShiftCloseInvoiceSummary(payload)
          .then((response) => {
            const { data, status } = response;
            if (status) {
              if (isPdf == "Y" && data.pdfPath) {
                window.open(data.pdfPath, "_blank");
              }
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          })
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      },
      getRevenueDropReport(user_shift_log_id) {
        let loader = this.$loading.show();
        let payload = {
          shift_id: [user_shift_log_id],
        };
        MasterService.GetRdrPdfReport(payload)
          .then((result) => {
            const { data } = result;
            window.open(data.tempFile);
            loader.hide();
          })
          .catch((err) => {
            console.log(err);
          });
      },
      getCinemaList: function() {
        MasterService.GetCinemasByRoles()
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.cinemaList = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      onSelectCinema: function(event) {
        this.selectedCinema = event;
        this.cinema_id = event.cine_id;
        console.log(event, "event");
        this.$store.dispatch("selectDropdownCinema", event);
      },
      excelDownload() {
        let excelRecords = this.shiftsCLoseValues;
        let loader = this.$loading.show();

        let payload = {
          currentPage: this.currentPage,
          limit: this.rows,
          searchValue: this.searchValue,
          startDate: this.startDate,
          endDate: this.endDate,
          cinema_id: this.cinema_id,
          shiftStatus: this.shiftStatus,
        };
        CinemasService.GetShiftClose(payload).then((response) => {
          let { data } = response;
          excelRecords = data.Records;
          loader.hide();
          if (data && data.status) {
            let data = [
              {
                sheet: "Shift Logs Report",
                columns: [
                  {
                    value: "usl_id",
                    label: "Shift Id",
                  },
                  {
                    value: "operator",
                    label: "Name",
                  },
                  {
                    value: (row) =>
                      row.up_employee_code ? row.up_employee_code : "--",
                    label: "Employee Code",
                  },
                  {
                    value: "login_date_time",
                    label: " Login Date Time",
                  },
                  {
                    value: "logout_date_time",
                    label: "Logout Date Time",
                  },
                  {
                    value: "BoxOfficeAmount",
                    label: "Box Office Amount",
                  },
                  {
                    value: "FnbAmount",
                    label: "FnB Amount",
                  },
                  {
                    value: "collection_amount",
                    label: "Collection Amount",
                  },
                  {
                    value: "Discount",
                    label: "Discount",
                  },
                  {
                    value: "system_amount",
                    label: "System Amount",
                  },
                  {
                    value: (row) => row.collection_amount - row.system_amount,
                    label: "Excess/Shortage",
                  },
                  {
                    value: (row) =>
                      row.shift_end == "Y" ? "Closed" : "Running",
                    label: "Shift End",
                  },

                  {
                    value: "createdAt",
                    label: "Created at",
                  },
                ],
                content: excelRecords,
              },
            ];
            let settings = {
              fileName: `ShiftLogs${new Date().getTime()}`,
            };
            xlsx(data, settings);
          }
        });
      },
      onSwitchActive: function(status) {
        this.shiftStatus = status;
      },
      goToRoute: function(path, { usl_id }) {
        this.$router.push({
          path: path,
          query: {
            shift_id: usl_id,
          },
        });
      },
      onSetValueSrc_id: function(
        e,
        values,
        Tempstatus,
        manager_user_id,
        index
      ) {
        this.src_id2 = values;
        this.manager_user_id2 = manager_user_id;
        this.status = Tempstatus;
        this.selectedIndex = index;
        if (status === "N") {
        } else {
        }
        this.$refs.test.show();
        // this.$nextTick(() => {
        //   this.$forceUpdate();
        // });
      },
      onChangeStatus: function(value, index) {
        const { user_id, role_name } = this.secureStore.get("USINFO");
        if (user_id == value.manager_user_id && role_name == "Super Admin") {
          if (confirm("Do you really want to update?")) {
            CinemasService.UpdateShiftClose(value);
          } else {
            if (this.shiftsCLoseValues[index].scr_approval_status == "N") {
              this.shiftsCLoseValues[index].scr_approval_status = "N";
            } else {
              this.shiftsCLoseValues[index].scr_approval_status = "Y";
            }
          }
        }
      },
      onSearch(event) {
        this.searchValue = event;
        this.currentPage = 1;
        this.getShiftCloseList({});
      },
      getShiftCloseList(params) {
        const { changeDate, newCurrentPage } = params;
        let loader = this.$loading.show();

        if (this.endDate && !this.startDate) {
          this.$toasted.show("Please select start date");
          return;
        }

        this.shiftsCLoseValues = [];
        let payload = {
          currentPage: changeDate ? newCurrentPage : this.currentPage,
          limit: this.perPage,
          searchValue: this.searchValue,
          startDate: this.startDate,
          endDate: this.endDate,
          cinema_id: this.cinema_id,
          shiftStatus: this.shiftStatus,
        };
        CinemasService.GetShiftClose(payload)
          .then((response) => {
            const { data } = response;
            loader.hide();
            if (data && data.status) {
              if (data.Records.length > 0) {
                if (data.PdfPath) {
                  this.PdfPath = data.PdfPath;
                }
                this.shiftsCLoseValues = data.Records;
                if (data.hasOwnProperty("paginationData")) {
                  if (data.paginationData.hasOwnProperty("total")) {
                    if (data.paginationData.total >= 10) {
                      this.rows = data.paginationData.total;
                    } else {
                      this.rows = data.paginationData.total;
                      this.selectedvalue = data.paginationData.total;
                    }
                  }
                }
                // if (data.totalRows >= 10) {
                //   this.rows = data.totalRows;
                // } else {
                //   this.rows = data.totalRows;
                //   this.selectedvalue = data.totalRows;
                // }
              } else {
                this.$toasted.show(data.message);
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      onClearDate: function(type) {
        switch (type) {
          case "start":
            this.startDate = null;
            break;
          case "end":
            this.endDate = null;
            break;
        }
      },
      onSelectDate: function(value, type) {
        let newDate = moment(value).format("YYYY-MM-DD");
        switch (type) {
          case "start":
            this.startDate = newDate;
            break;
          case "end":
            this.endDate = newDate;
            break;
        }
      },
      handleFetch() {
        this.getShiftCloseList({ newCurrentPage: 1, fromDate: true });
      },
      okUpdateStatus() {
        const { user_id, role_name } = this.secureStore.get("USINFO");
        if (this.status == "Y") {
          this.payloadStatus = "N";
        } else {
          this.payloadStatus = "Y";
        }
        if (user_id == this.manager_user_id2 && role_name == "Super Admin") {
          this.$refs.test.hide();
          let payload = {
            scr_id: this.src_id2,
            scr_approval_status: this.payloadStatus,
          };
          CinemasService.UpdateShiftClose(payload)
            .then((response) => {
              const { data } = response;
              if (data && data.status) {
                this.$toasted.show(data.message);
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError); //message
        }
      },
      cancelUpdateStatus() {
        if (
          this.shiftsCLoseValues[this.selectedIndex].scr_approval_status == "Y"
        ) {
          this.shiftsCLoseValues[this.selectedIndex].scr_approval_status = "N";
        } else {
          this.shiftsCLoseValues[this.selectedIndex].scr_approval_status = "Y";
        }
        this.$refs.test.hide();
      },
      onChangePagination: function(event) {
        if (event === undefined) {
          this.currentPage = 1;
          this.getShiftCloseList({});
        } else {
          this.currentPage = event;
          this.getShiftCloseList({});
        }
      },
      onDropDownChangeValue(event) {
        if (event == "All") {
          this.perPage = this.rows;
          this.selectedvalue = event;
          this.onChangePagination();
        } else {
          // console.log("Numbers :", event);
          this.selectedvalue = event;
          this.perPage = event;
          // console.log("perPage :", this.perPage);
          this.onChangePagination();
        }
      },
    },
  };
</script>
<style>
  .btn-primary-sm {
    padding: 3px 6px;
    background-color: var(--blue);
    color: white;
    border: 1px solid var(--blue);
    border-radius: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ShiftCloseComponent/shiftsClose.vue